import { followUpSession } from '@uplift/api';
import { DateFormats, TimeFormats } from '@uplift/constants';
import { useTimezone } from '@uplift/contexts';
import { CalendarDateService } from '@uplift/services';
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

export const useFollowUpAppointmentDate = (appointmentId: string) => {
  const timezone = useTimezone();

  const { data: nextSession, isInitialLoading: isLoading } = useQuery(
    [ 'next-session', appointmentId ],
    async ({ queryKey: [ _cacheKey, appointmentId ] }) => {
      const data = await followUpSession(appointmentId);

      return data.data;
    },
    {
      enabled: !!appointmentId,
    }
  );

  const dateOfNextAppointment = useMemo(() => {
    if (!nextSession) return null;
    const dateObj = CalendarDateService.date(nextSession.fromDatetime).tz(timezone);
    const date = dateObj.format(DateFormats['MMM D, YYYY']);
    const time = dateObj.format(TimeFormats['h:mm']);
    const meridiem = dateObj.format('a').replace(/(.{1})/g, '$1.');

    return { date, time, meridiem };
  }, [ nextSession, timezone ]);

  return { dateOfNextAppointment, loading: isLoading };
};
